import React from 'react';

import style from './check.module.scss';
import Icon from '@components/icon-component';

const header = ({ handleBackClick, pageHeaderTitle }) => {
  return (
    <div>
      <div className={`px-4 md:px-8 py-7 ${style.header} `}>
        {/* <p className={style.cancelClass} onClick={() => handleBackClick()}>
          Cancel
        </p> */}

        <Icon name={'left-icon-white'} onClick={handleBackClick} className={style.cancelClass} />
        <h1 className={` ${style.addClass} h1-semibold`}>{pageHeaderTitle}</h1>

        <div className={style.invisibleDiv}></div>
      </div>
    </div>
  );
};

export default header;
